<template>
	<div v-loading="l">
		<el-dialog title="审批" :visible.sync="show" width="30%">
			<det :row="row">
				<template v-slot:zhuangxiu>
					<div style="padding: 10px;">
						<el-upload action="/api/admin/roomManage/uploadRoomFile" name="file" :show-file-list="false"
							:on-success="success" :headers="headerData">
							<el-button size="small" type="primary">上传审核附件</el-button><span>{{fileName}}</span>
						</el-upload>
					</div>
				</template>
				<template v-slot:tuizu>
					<div style="padding: 10px;">
						<el-checkbox v-model="isRestore">店铺恢复原始状态</el-checkbox>
						<el-checkbox v-model="isSettle">租金结清</el-checkbox>
					</div>
				</template>
				<template v-slot:rzsq>
					<div style="margin-left: 10px;">
						<el-form :inline="true" >
							<el-form-item label="审批意见">
								<el-input type="textarea" placeholder="请输入审批意见" v-model="opinion"></el-input>
							</el-form-item>
						</el-form>
					</div>
				</template>
			</det>
			<el-radio v-model="radio" label="1">同意</el-radio>
			<el-radio v-model="radio" label="2">拒绝</el-radio>
			<el-input v-if="radio=='2'" v-model="reason" placeholder="请输入拒绝原因"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
			<!-- 	<el-button type="danger" @click="ok(false)">拒 绝</el-button>
				<el-button type="primary" @click="ok(true)">同 意</el-button> -->
				<el-button type="primary" @click="ok(true)">确 认</el-button>
			</span>
		</el-dialog>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
			<el-table-column label="流程名称" align="center">
				<template slot-scope="{row}">{{jc(row)}}</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row)">详情</el-button>
				</template>
			</el-table-column>
			<el-pagination background :page-size="pageSize" layout="total, prev, pager, next,sizes"
				@current-change="handleCurrentChange" :total="totalNum" @size-change="handleSizeChange" />
		</el-table>
	</div>
</template>

<script>
	import det from "./det.vue"
	export default {
		components: {
			det
		},
		data() {
			return {
					radio: '1',
				opinion:'',
				totalNum: 0, //总页数
				isRestore:false,
				isSettle:false,
				headerData: {
					Authorization: sessionStorage.token
				},
				pageSize: 10, //
				currentPage: 1, //当前页号
				data: [],
				row: {},
				show: false,
				reason: "",
				filePath: "",
				fileName: "",
				l:false
			}
		},
		computed: {
			jc() {
				return (row) => {
					let processKey = row.processKey
					if (processKey == "renovationProcess") {
						return "装修"
					}
					if (processKey == "shopReturnProcess") {
						return "退租"
					}
					if (processKey == "contractChange") {
						return "合同"
					}
					if (processKey == "attractInvestmentManage") {
						return "招商"
					}
					if (processKey == "visitProcess") {
						return "访客"
					}
					if (processKey == "subscribeLookProcess") {
						return "约看房"
					}
					if (processKey == "complaintProcess") {
						return row.type
					}
					if (processKey == "materialApplyProcess") {
						return "物资搬运"
					}
					if (processKey == "repairProcess") {
						return "报修"
					}
					if (processKey == "serviceProcess") {
						return "服务"
					}
					if (processKey == "checkApplyProcess") { // 退换房
						return row.applyType
					}
					if(processKey=="checkInProcess"){
						return "入住申请"
					}
					if(processKey=="meetingProcess"){
						return "商务审批"
					}
				}
			}
		},
		methods: {
			handleSizeChange(val) {
				this.pageSize = val;
				this.getAll();
			},
			handleCurrentChange(val) {
				console.log(val);
				this.currentPage = val;
				this.getAll();
			},
			success(res) {
				this.filePath = res.data.filePath
				this.fileName = res.data.fileName
			},
			ok(type) {
				//renovationProcess 装修
				//shopReturnProcess 退租
				//contractChange 合同
				//attractInvestmentManage 招商
				//visitProcess  访客流程
				//subscribeLookProcess  约看房流程
				//complaintProcess  投诉流程
				// materialApplyProcess  物资搬运流程
				if(this.radio=='1'){
					type=true
				}else{
					type=false
				}
				console.log(type)
				let url = ""
				let t = "post"
				let name = ""

				if (this.row.processKey == "repairProcess") {
					url = `/api/oa/apply/repairApproval`
					name = "报修流程"
				}
				if (this.row.processKey == "serviceProcess") {
					url = `/api/oa/apply/serviceApproval`
					name = "服务流程"
				}
				if (this.row.processKey == "checkApplyProcess") {
					url = `/api/oa/apply/checkOutApproval`
					name = "退换房流程批准"
				}
				if (this.row.processKey == "complaintProcess") {
					url = `/api/oa/apply/complaintApproval`
					name = "投诉流程"
				}
				if (this.row.processKey == "materialApplyProcess") {
					url = `/api/oa/apply/materialApplyApproval`
					name = "物资搬运流程"
				}
				if (this.row.processKey == "subscribeLookProcess") {
					url = `/api/oa/apply/subLookApproval`
					name = "约看房流程"
				}
				if (this.row.processKey == "visitProcess") {
					url = `/api/oa/apply/visitApproval`
					name = "访客流程"
				}
				if (this.row.processKey == "renovationProcess") {
					url = `/api/oa/decoration/approval`
					name = "装修"
				}
				if (this.row.processKey == "shopReturnProcess") {
					url = `/api/oa/shopReturn/approval`
					name = "退租"
				}
				if (this.row.processKey == "contractChange") {
					url = `/api/oa/contract/approval`
					name = "合同"
				}
				if (this.row.processKey == "attractInvestmentManage") {
					url = `/api/oa/attract/approval`
					name = "招商"
					t = "get"
				}
				if(this.row.processKey=="checkInProcess"){
					url=`/api/oa/apply/checkInApproval`
					name='入住'
				}
				if(this.row.processKey=="meetingProcess"){
					url=`/api/oa/apply/meetingApproval`
					name='商务审批'
				}
				this.show = false;
				let taskId = this.row.processTaskInfos[0].taskId
				this.row.processTaskInfos.forEach(item=>{
					if(item.activityName=="物业审批"&&sessionStorage.roleId=="10"){
						taskId = item.taskId
					}
					if(item.activityName=="商管审批"&&sessionStorage.roleId=="11"){
						taskId = item.taskId
					}
				})
				this.$http[t](url +
					`?approved=${type}&processId=${this.row.processTaskInfos[0].processId}&taskId=${taskId}&reason=${this.reason}&wuYe=${sessionStorage.roleId == 10}`, {
						name,
						approved: type,
						processId: this.row.processTaskInfos[0].processId,
						taskId,
						reason: this.reason,
						opinion:this.opinion,
						wuYe: sessionStorage.roleId == 10,
						filePath: this.filePath,
						fileName: this.fileName,
						isRestore:this.isRestore?"是":"否",
						isSettle:this.isSettle?"是":"否",
					}).then(res => {
					if (res.data.code == 0) {
						this.$message.success("操作成功")
						this.getAll()
					} else {
						this.$message.error("操作失败")
					}
				})
			},
			getRow(row) {
				this.row = row
				this.show = true
			},
			getAll() {
				this.l = true
				this.$http.post(`/api/oa/contract/queryListByManagerId`, {
					"managerId": sessionStorage.roleId,
					"pageNum": this.currentPage,
					"pageSize": this.pageSize
				}).then(res => {
					this.data = res.data.data
					this.l = false
				})
			}
		},
		mounted() {
			this.getAll()
		}
	}
</script>

<style>
</style>
